import { Loading } from '@postidigital/posti-components/build/animations'
import React from 'react'
import styled from 'styled-components'

export const ViewLoading: React.FC = () => {
  return (
    <StyledCenter>
      <Loading isBrand preset="postiOrange60" size="xl" />
    </StyledCenter>
  )
}

const StyledCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 35%;
`
